/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Developer_Edit_TitleInputs */



/**
* | output |
* | --- |
* | "Edit {name}" |
*
* @param {Developer_Edit_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const developer_edit_title = /** @type {((inputs: Developer_Edit_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Developer_Edit_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Modifier ${i?.name}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Editar ${i?.name}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Editar ${i?.name}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Modifica ${i?.name}`)
	return /** @type {LocalizedString} */ (`Edit ${i?.name}`)
});